import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=45927d54&scoped=true&"
import script from "./Licenses.vue?vue&type=script&lang=ts&"
export * from "./Licenses.vue?vue&type=script&lang=ts&"
import style0 from "./Licenses.vue?vue&type=style&index=0&id=45927d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45927d54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
